import React from 'react'
import LoginSection from '../sections/LoginSection/LoginSection'

const Login = () => {
  return (
    <LoginSection />
  )
}

export default Login